export default {
  CUSTOMER_SYNC: 'CUSTOMER_SYNC',
  TRANSACTIONS_SYNC: 'TRANSACTION_SYNC',
};
